<script>
import Loader from "@/components/loader";
import api from "@/services/api";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";

/**
 * Nav-bar Component
 */
export default {
  components: {Loader, Multiselect},
  data() {
    return {
      loading: false,
      file: null,
      selectValue: {
        value: false,
        name: 'Non'
      },
      selectOptions: [
        {
          value: false,
          name: 'Non'
        },
        {
          value: true,
          name: 'Oui'
        }
      ],
    };
  },
  methods: {
    change(event) {
      const file = event.target.files[0];

      if (file !== undefined) {
        this.file = file;
      }
    },

    submit() {
      if (!this.file) {
        return;
      }

      this.loading = true;

      const formData = new FormData();
      formData.append('file', this.file);
      formData.append('6x6', this.selectValue.value);

      return api.post("inventories", formData, 'import', {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
      ).then(() => {
        Swal.fire('Le fichier est maintenant en cours d\'import',
            'Les changements seront visibles progressivement durant la procédure.',
            'success');
      }).finally(() => {
        this.loading = false;
      });
    }
  },
};
</script>

<template>
  <Loader :loading="loading">
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col>
            <input class="form-control float-end" type="file" id="import-file" @change="change"
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="mt-3">
            <b-form-group label="6x6" label-for="select">
              <multiselect id="select" v-model="selectValue" :options="selectOptions" track-by="value" label="name"
                           :show-labels="false">
              </multiselect>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <div class="text-right">
      <b-button variant="primary" @click="submit">Import</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </Loader>
</template>
